import { render, staticRenderFns } from "./invest2.vue?vue&type=template&id=249a9653&scoped=true"
import script from "./invest2.vue?vue&type=script&lang=js"
export * from "./invest2.vue?vue&type=script&lang=js"
import style0 from "./invest2.vue?vue&type=style&index=0&id=249a9653&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a9653",
  null
  
)

export default component.exports